import { site } from '@yola/ws-sdk';
import segment from 'src/js/modules/analytics/segment';

const trackBlockLayoutSwitched = ({
  oldBlockId,
  newBlockId,
  oldBlockVariationId,
  newBlockVariationId,
  oldText,
  newText,
}) => {
  const {
    trackers: { trackEvent },
    constants,
  } = segment;

  trackEvent(constants.events.BLOCK_LAYOUT_SWITCHED, {
    pageId: site.accessors.getActivePageId(),
    oldBlockId,
    newBlockId,
    oldBlockVariationId,
    newBlockVariationId,
    oldText,
    newText,
  });
};

export default trackBlockLayoutSwitched;
